<template>
  <footer class="footer">
    <div class="container">
      <div class="ft-hd f-cb">
        <div class="left">
          <div class="logo-box">
            <a href="/" class="logo"
              ><img src="@/assets/logo-m.png" alt="" width="62" height="50" />
              <div class="txt">
                <h5>傲梅备份</h5>
                <p>AomeiBackup</p>
              </div>
            </a>
            <p class="ph-num">永保全球数据更安全</p>
          </div>
        </div>
        <div class="right">
          <div class="wx">
            <p class="txt">微信公众号</p>
            <img src="@/assets/wx_code.png" alt="" width="80px" height="80px" />
          </div>
          <div class="wb">
            <p class="txt">微博</p>
            <img src="@/assets/wb_code.png" alt="" width="80px" height="80px" />
          </div>
        </div>
        <ul class="main">
          <li><a href="/partner.html">合作伙伴</a></li>
          <li><a href="/service.html">服务支持</a></li>
          <li><a href="/easybackup-tutorials/">个人备份指南</a></li>
          <li><a href="/enterprise-backup/">企业备份指南</a></li>
          <li><a href="/about.html">关于我们</a></li>
        </ul>
      </div>
      <div class="ft-bt">
        版权所有© 2010-2024傲梅科技.&nbsp;&nbsp;<a href="http://beian.miit.gov.cn/" target="_blank"
          >蜀ICP备16032123号</a
        >
      </div>
    </div>
  </footer>
</template>

<script>
// import { defineComponent } from '@vue/composition-api'

export default {
  name: "AbFooter",
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
<style lang="less" scoped>
.footer {
  padding: 25px 0 15px;
  background-color: #141924;
  color: #7e7f82;
  line-height: 1.5;

  .left,
  .right {
    position: relative;
    float: left;
    width: 250px;
    margin: 0 -250px 0 0;
  }

  .right {
    float: right;
    margin: 0 0 0 -250px;
    text-align: right;
    font-size: 0;

    & > div {
      display: inline-block;
      text-align: center;
      font-size: 14px;

      .txt {
        margin-bottom: 5px;
      }
    }

    .wx {
      margin-right: 30px;

      .txt::before {
        background-position: 0 0;
      }
    }

    .wb {
      .txt::before {
        background-position: -60px 0;
      }
    }

    .txt::before {
      content: "";
      display: inline-block;
      width: 22px;
      height: 18px;
      vertical-align: middle;
      margin-right: 3px;
      background: url("../../assets/logo_wei.png") no-repeat;
      //   background: url('@/assets/abackup-icon-small-all.png') no-repeat;
    }

    img {
      vertical-align: top;
    }
  }

  .logo h5,
  a,
  p {
    color: #7e7f82;
  }

  a:hover {
    color: #fff;
  }

  .ph-num {
    font-size: 16px;
    margin-top: 15px;
  }

  ul.main {
    float: left;
    width: 100%;
    text-align: center;
    padding: 30px 250px;

    li {
      display: inline-block;
      margin-left: 5%;

      &:first-child {
        margin-left: 0;
      }
    }
  }

  .ft-bt {
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
  }
}

@media all and (max-width: 767px) {
  .footer {
    text-align: center;

    ul.main {
      width: 100%;
      float: none;
      padding: 0;
      text-align: center;
      margin: 0 0 20px;
    }

    .left,
    .right {
      float: none;
      display: inline-block;
      margin: 0 0 20px;
      text-align: center;
    }

    .logo-box {
      float: none;
    }
  }
}
@media (max-width: 450px) {
  .footer ul.main {
    text-align: left;
    width: auto;
  }
  .footer ul.main li {
    &:first-child {
      margin: 2px 10px;
    }
    // width: 85px;
    text-align: left;
    margin: 2px 10px;
  }
}
@media (max-width: 388px) {
  .footer ul.main li {
    width: 85px;
  }
}
</style>
